import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  output,
  signal,
  SimpleChanges,
} from '@angular/core';

/*
 * Componente que renderiza la lista de meses seleccionables
 * */
@Component({
  selector: 'app-month-pills',
  imports: [DatePipe],
  templateUrl: "./month-pills.component.html",
  styleUrl: "./month-pills.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthPills {
  /** Clase del contenedor MonthPillsComponent */
  @HostBinding('class') class =
    'col-lg-2 offset-lg-0 col-md-10 d-none d-lg-block col-12 offset-2 mt-5 mt-lg-0 nav events-nav';
  /** Variable de entrada que recibe las fechas */
  readonly dates = input.required<Date[]>();
  /** Variable de entrada que recibe el lenguaje */
  readonly lang = input<string>('');
  /** Mes seleccionado*/
  protected readonly monthSelected = signal<number>(0);
  /** Variable de salida que emite el valor del mes seleccionado */
  readonly selectedMonth = output<number>();
  /** Lista de fechas */
  protected readonly monthDates = signal<Date[]>([]);

  constructor() {}

  /** Ciclo de vida de angular, que detecta cuando una variable de entrada sufre un cambio */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dates) {
      if (this.dates()) {
        this.getMonths();
      }
    }
  }

  /**
   * Método que obtiene los meses que existen entre las fechas recibidas mediante @Input() dates
   * */
  private getMonths(): void {
    let months = this.dates()?.map((d) => d.getMonth());
    months = months.filter((m, i) => months.indexOf(m) === i);
    months.sort();
    const monthDates = months.map((m) => {
      const date = new Date();
      date.setMonth(m);
      return date;
    });
    this.monthDates.set(monthDates);
    this.setMonth(this.monthDates()[0].getMonth());
  }

  /**
   * Método que setea los meses, y emite al componente padre los meses que existen
   * */
  protected setMonth(month: number): void {
    this.monthSelected.set(month);
    this.selectedMonth.emit(month);
  }
}
